import React from 'react';
import classNames from 'classnames';

type Props = {
  id: string;
  className?: string;
};

export const HelpText: React.FC<Props> = ({
  id,
  className,
  children,
  ...rest
}) => (
  <div
    className={classNames('text-sm text-teal-500', className)}
    id={id}
    {...rest}
  >
    {children}
  </div>
);
